/* istanbul ignore file */
import { Text, constants } from '@adc/ui-adc'
import classNames from 'classnames/bind'
import employeeDecisionIcon from '../../../../assets/employee_decision.svg'
import perfomanceGaugeIcon from '../../../../assets/perfomance_gauge.svg'
import seoLaptopIcon from '../../../../assets/seo_laptop.svg'
import styles from './styles.scss'

const cx = classNames.bind(styles)
const { ColorNames } = constants

const sellerReasons = [
  {
    icon: perfomanceGaugeIcon,
    title: 'Close Fast',
    description: 'Close in as little as 30 days with our streamlined process',
  },
  {
    icon: seoLaptopIcon,
    title: 'Transparency',
    description: 'See all offers and bids in real-time',
  },
  {
    icon: employeeDecisionIcon,
    title: 'Control',
    description: 'You decide the terms, timeline, and which offer to accept',
  },
]

const WhySellersChooseAuction = () => {
  return (
    <div className={cx('why-sellers-full-width-section')}>
      <div className={cx('landing-section')}>
        <div className={cx('header-section')}>
          <Text.Header as='h1'>Why Sellers Choose Auction.com</Text.Header>
        </div>

        <div className={cx('why-sellers-container')}>
          {sellerReasons.map((reason, index) => (
            <div className={cx('why-sellers-column')} key={index}>
              <div className={cx('why-sellers-section')}>
                <div className={cx('why-sellers-icon-container')}>
                  <img src={reason.icon} alt={reason.title} />
                </div>
                <div className={cx('why-sellers-text-content')}>
                  <Text
                    style={{ lineHeight: '28px' }}
                    className={cx('why-sellers-text-title')}
                    weight='medium'
                    size='big'
                  >
                    {reason.title}
                  </Text>
                  <Text
                    className={cx('why-sellers-text-description')}
                    color={ColorNames.Gray}
                    size='small'
                    weight='normal'
                    style={{ lineHeight: '24px' }}
                  >
                    {reason.description}
                  </Text>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhySellersChooseAuction
